import React, { useState, useCallback } from "react";
import { Box, SpeedDial, SpeedDialIcon } from "@mui/material";
import AnnouncementsTable from "../table/AnnoucementsTable";
import AnnouncementDialog from "../dialog/AnnouncementsDialog";

const AnnouncementsPage = () => {
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const [values, setValues] = useState(null); // anúncio selecionado ou null
  const [changed, setChanged] = useState(false);

  const handleChanged = useCallback(() => setChanged((v) => !v), []);

  const handleNewAnnouncement = () => {
    setEditing(false);
    setValues(null);
    setOpen(true);
  };

  const handleEdit = (row) => {
    setEditing(true);
    setValues(row || null);
    setOpen(true);
  };

  return (
    <Box sx={{ p: 1, position: "relative" }}>
      {/* Dialog Create/Edit */}
      <AnnouncementDialog
        open={open}
        setOpen={setOpen}
        editing={editing}
        values={values}
        setValues={setValues}
        onChanged={handleChanged}
      />

      {/* SpeedDial para novo */}
      <SpeedDial
        ariaLabel="Novo anúncio"
        sx={{ position: "fixed", bottom: 70, right: 16 }}
        icon={<SpeedDialIcon />}
        onClick={handleNewAnnouncement}
      />

      {/* Tabela */}
      <AnnouncementsTable
        onEdit={handleEdit}
        changed={changed}
        onChanged={handleChanged}
      />
    </Box>
  );
};

export default AnnouncementsPage;
